import { Form } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import FieldError from '../../../../../shared/fields-errors/field-error';
import { useEffect } from 'react';
import "./additional-field.scss"
function NumberField({ fieldInfo,parentIndex, entityID, CustomFieldID, fieldResponseKey, multiFormIndex, answerContext, borderColor, boxShadowColor }) {
    const { register, formState:{errors},setValue } = useFormContext();

    useEffect(() => {
        if (entityID) {
            setValue(`${fieldResponseKey ? fieldResponseKey : 'field_answers'}.${parentIndex}.answers.${0}.entity_id`, entityID);
        }
    }, [entityID]);

    useEffect(() => {
        if (CustomFieldID) {
            setValue(`${fieldResponseKey ? fieldResponseKey : 'field_answers'}.${parentIndex}.answers.${0}.custom_field_id`, CustomFieldID);
        }
    }, [CustomFieldID]);

    useEffect(() => {
        if (fieldResponseKey) {
            setValue(`${fieldResponseKey}.${parentIndex}.answers.${0}.answer_context`, answerContext);
        }
    }, [fieldResponseKey])

    return (
        <>
            <Form.Group >
                <Form.Label>
                <strong className="label-text" >
                    {fieldInfo?.field_is_required ? <span className='text-danger'>*</span> : ''} {fieldInfo?.field_label}
                </strong>
              </Form.Label>
                <Form.Control
                className=' program-form-control'
                style={{borderRadius: '8px', 
                        '--border-color': borderColor || "#155C4E",
                        '--box-shadow-color': boxShadowColor,}}
                    {...register(`${fieldResponseKey ? fieldResponseKey : 'field_answers'}.${parentIndex}.answers.${0}.number_value`,{
                         required: {
                            value: fieldInfo?.field_is_required,
                            message:'Field is required'
                        }
                    })}
                    type="number"
                     />
                          {
                         multiFormIndex >= 0 ? 
                         (errors?.participants?.[multiFormIndex]?.participant_answers?.[parentIndex]?.answers?.[0]?.number_value ? 
                            <FieldError 
                                        message={errors?.participants?.[multiFormIndex]?.participant_answers?.[parentIndex]?.answers?.[0]?.number_value?.message} /> : ''
                         ) 
                         : 
                    (errors?.[fieldResponseKey ? fieldResponseKey : 'field_answers']?.[parentIndex]?.answers?.[0]?.number_value ? 
                                        <FieldError 
                                        message={errors?.[fieldResponseKey ? fieldResponseKey : 'field_answers'][parentIndex]?.answers[0]?.number_value?.message} /> : '')
                     }
            </Form.Group>
            {
                fieldInfo?.field_description ? 
                <p className='cf-hint'>{fieldInfo?.field_description}</p> : ''
            }

            {
                CustomFieldID ?
                    <input type='hidden' {...register(`${fieldResponseKey ? fieldResponseKey : 'field_answers'}.${parentIndex}.answers.${0}.custom_field_id`, {
                        value: CustomFieldID
                    })} /> : ''
            }
            {
                entityID ?
                    <input type='hidden' {...register(`${fieldResponseKey ? fieldResponseKey : 'field_answers'}.${parentIndex}.answers.${0}.entity_id`, {
                        value: entityID
                    })} /> : ''
            }
            
        </>
    );
}

export default NumberField;